import type {
  StatementAffinity,
  StatementHistoryStatistics,
} from "@exagens/behavioral-insight-console-client";
import { from, mergeMap, type Observable } from "rxjs";
import type { CatalogPeriod } from "@/constants/sparxsCatalogFilters";
import { CHANNEL_DETAIL_HISTORY_MONTHS } from "@/features/channelDetail/constants";
import type { UserProfile } from "@/hooks/useUserProfile";
import { getStatementsStatisticApi } from "@/services/consoleApiLoaders";
import { requestConfiguration } from "@/services/statistics.service";
import { retryOnUnauthorized } from "@/store/consoleApi/retryOnUnauthorized";

export const getStatementAffinityForPeriod = (
  profile: UserProfile,
  period: CatalogPeriod,
): Observable<StatementAffinity> => {
  return from(getStatementsStatisticApi()).pipe(
    mergeMap((api) =>
      api.getStatementAffinity({
        ...requestConfiguration(profile),
        period,
      }),
    ),
    retryOnUnauthorized(),
  );
};

export const getStatementHistoryForChannelDetail = (
  profile: UserProfile,
): Observable<StatementHistoryStatistics[]> => {
  return from(getStatementsStatisticApi()).pipe(
    mergeMap((api) =>
      api.getStatementHistoryStatistics({
        ...requestConfiguration(profile),
        months: CHANNEL_DETAIL_HISTORY_MONTHS,
      }),
    ),
    retryOnUnauthorized(),
  );
};
